import { LegendKey } from "../../../../models/chart_model";
import { getColor } from "../../../../utility/Colors";

export function lightenColor(color: string, percent: number): string {
  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1)}`;
}

export const getLegendColorKey = (legend: LegendKey, index = 0): string => {
  const dataKey = `${legend.dataKey ?? ""}`.trim();
  const name = `${legend.name ?? ""}`.trim();

  const key =
    dataKey.length > 0 ? dataKey : name.length > 0 ? name : `legend_${index}`;

  // Strip unit suffixes to maintain color consistency across filter changes (MW/MWh/LU)
  return key.replace(/_(mw|mwh|lu|rs_mwh)$/i, "");
};

export const getLegendColor = (
  legend: LegendKey,
  index: number,
  selectedLegends: LegendKey[],
  isLegend?: boolean,
): string => {
  const isSelected =
    selectedLegends.some((item) => item.dataKey === legend.dataKey) ||
    selectedLegends.length === 0;
  const legendColorKey = getLegendColorKey(legend, index);
  return isSelected
    ? ((isLegend ? legend.legendColor : legend.stroke) ??
        legend.stroke ??
        getColor(index, legendColorKey))
    : "#E0E0E0";
};
